module.exports = __webpack_public_path__ + "img/chongya-3.ff84015b.png";